/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface OrganizationsRespondInvitation$Params {

/**
 * The ID of the organization
 */
  organizationId: string;

/**
 * The ID of the invitation
 */
  invitationId: string;
      body: {

/**
 * The response action to the invitation.
 */
'action': 'accept' | 'decline';

/**
 * The token associated with the invitation.
 */
'token'?: string;
}
}

export function organizationsRespondInvitation(http: HttpClient, rootUrl: string, params: OrganizationsRespondInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The updated status of the invitation
 */
'status'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsRespondInvitation.PATH, 'patch');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('invitationId', params.invitationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * The updated status of the invitation
       */
      'status'?: string;
      }>;
    })
  );
}

organizationsRespondInvitation.PATH = '/organizations/{organizationId}/users/invitations/{invitationId}';
